<template>
  <div class="loader" :class="{box_shadow: box_shadow}">
    <loader-icon :size="100"/>
  </div>
</template>

<script>
import LoaderIcon from "../../components/icons/LoaderIcon";
export default {
  name: "Loader",
  components: {LoaderIcon},
  props: {
    box_shadow: {
      type: Boolean,
      default: false
    }
  }
}
</script>
